import { createStore } from 'owa-satcheljs';
import type YammerBootstrapStore from './schema/YammerBootstrapStore';
import { type BootstrapStatus } from './schema/YammerBootstrapStore';

const defaultExport: () => YammerBootstrapStore = createStore<YammerBootstrapStore>(
    'yammerBoostrapStore',
    {
        bootstrapStatus: 0,
    }
);
export default defaultExport;
